import { axios, Response } from '../index'

const replyMembershipRequest = (
  groupId: string,
  membershipRequestId: number,
  status: string
): Response<null> => {
  return axios.put(
    `/v1/groups/${groupId}/membership-requests/${membershipRequestId}`,
    { newStatus: status }
  )
}

export default replyMembershipRequest
